import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/SILANGIT-FIX/fe-silangit-app-fix/src/app/tarif-layanan/components/tarif-layanan-client.jsx");
